
/* DEBIT_NOTE */
export const GET_DEBIT_NOTE_LISTING = "GET_DEBIT_NOTE_LISTING";
export const GET_DEBIT_NOTE_LISTING_SUCCESS = "GET_DEBIT_NOTE_LISTING_SUCCESS";
export const GET_DEBIT_NOTE_LISTING_FAIL = "GET_DEBIT_NOTE_LISTING_FAIL";

export const GET_DEBIT_NOTE_DETAILS = "GET_DEBIT_NOTE_DETAILS";
export const GET_DEBIT_NOTE_DETAILS_SUCCESS = "GET_DEBIT_NOTE_DETAILS_SUCCESS";
export const GET_DEBIT_NOTE_DETAILS_FAIL = "GET_DEBIT_NOTE_DETAILS_FAIL";

export const EXPORT_DEBIT_NOTE = "EXPORT_DEBIT_NOTE";
export const EXPORT_DEBIT_NOTE_SUCCESS = "EXPORT_DEBIT_NOTE_SUCCESS";
export const EXPORT_DEBIT_NOTE_FAIL = "EXPORT_DEBIT_NOTE_FAIL";

export const RESET_DEBIT_NOTE_STATE = 'RESET_DEBIT_NOTE_STATE';
export const RESET_DEBIT_NOTE_ACTION_STATE = 'RESET_DEBIT_NOTE_ACTION_STATE';